import { services2 } from '/api/services2';

export const eventsMapperService = services2.appEventsMapperService;
export const eventsMapperServiceName = eventsMapperService.getClassName();

// the same names as the names of the methods in /common/scripts/definitions/script-hooks.d.ts
export const EVENTS_SAVE_HOOK_NAME = 'onEventsSave';
